// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__-adld","title":"AfterBackImages_title__32Noj","images":"AfterBackImages_images__2Wfod"};